import React, { useEffect, useState } from "react";
import MyNavbar from "../component/navbar";
import Navbarinner from "../component/navbarinner";
import { Col, Container, Row, Button } from "react-bootstrap";
import play from "../assets/images/play_btn.svg";
import MyFooter from "../component/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getFaqlistAction } from "../ApiAction/api";

// import { Button } from "bootstrap";

export default function Home(props) {
  const [record, setRecord] = useState([]);
  const [loader, setloader] = useState(false);
  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    getFaqList();
  }, []);

  useEffect(() => {
    let refCode = null;

    // Method 1: Check URL query parameters (most common)
    const urlParams = new URLSearchParams(window.location.search);
    refCode = urlParams.get("ref");

    // Method 2: Check hash parameters (for some mobile apps)
    if (!refCode && window.location.hash) {
      const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
      refCode = hashParams.get("ref");
    }

    // Method 3: Check path parameters as fallback
    if (!refCode) {
      // More robust path matching
      const pathMatch = window.location.pathname.match(/\/(?:ref|referral)\/([^\/]+)/i);
      if (pathMatch) refCode = pathMatch[1];
    }

    // Debug logging
    console.log("Extracted referral code:", refCode);
    console.log("Full URL:", window.location.href);
    console.log("Query params:", window.location.search);
    console.log("Hash:", window.location.hash);
    if (refCode) {
      // Store referral code
      localStorage.setItem("referralCode", refCode);
      console.log("Referral code stored:", refCode);

    }
  }, []);


  const getFaqList = async () => {
    setloader(true);
    try {
      const { status, result } = await getFaqlistAction();
      if (status) {
        setRecord(result);
      } else {
        setRecord([]);
      }
    } catch (err) {
      console.error("Error fetching FAQ list:", err);
    }
    setloader(false);
  };
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <MyNavbar />
      <section>
        <Container>
          <div
            className="banner_sec"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="500"
          >
            <Row>
              <Col lg="6" xl="6" xxl="5">
                <div className="ban_sec_head">
                  <h1 className="tittle ">
                    The ultimate play-to-earn experience starts here.
                  </h1>
                  <Button className="primary_btn mt-3">Get’s Started</Button>
                </div>
              </Col>
              <Col lg="6" xl="6" xxl="7">
                <div className="ban_img">
                  <img
                    src={require("../assets/images/banner_img.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={776}
                    height={436}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="me-0 ms-0 sec_2">
        <div className="">
          <Container>
            <div className="sec_2_head">
              <h2
                className="sub_tittle"
                data-aos="fade-up"
                data-aos-offset="100"
                data-aos-duration="1000"
              >
                Game on, Earn on
              </h2>
              <p
                className="para"
                data-aos="fade-up"
                data-aos-offset="100"
                data-aos-duration="1000"
              >
                Outsource your betting to the Professor, who places bets on your
                behalf through integrated gaming platforms. Users receive 98% of
                the profits, with 1% going to the Admin and 1% to the Professor.
              </p>
            </div>
          </Container>
        </div>
      </section>
      <section className=" sec_3">
        <div className="container">
          <h2
            className="sub_tittle mb-5"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            Explore our Games
          </h2>
          <div
            className="black_card"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            <Row>
              <Col xl="5">
                <div className="tag_tittle">Wingo</div>
                <div className="tag_head">
                  <div className="card_head">
                    <div className="outline">Aviator</div>
                    Aviator
                  </div>
                </div>

                <p className="card_p">
                  Experience the Thrill of Flight with Aviator
                </p>
                <Button className="primary_btn mt-3  d-none  d-xl-block">
                  Begin Your Journey
                </Button>
              </Col>
              <Col xl="7">
                <div className="img_right">
                  <img
                    src={require("../assets/images/banner_img_2.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={700}
                    height={391}
                  />
                  <Button className="primary_btn mt-4 d-block  d-xl-none">
                    Get’s Started
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <div
            className="black_card blue"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            <Row>
              <Col xl="5">
                <div className="tag_tittle">Wingo</div>
                <div className="tag_head">
                  <div className="card_head">
                    <div className="outline">Number</div>
                    Number
                  </div>
                </div>

                <p className="card_p">
                  Test Your Luck and Skill with the Wingo Number Game!
                </p>
                <Button className="primary_btn mt-3 d-none  d-xl-block">
                  Join the Action!
                </Button>
              </Col>
              <Col xl="7">
                <div className="img_right">
                  <img
                    src={require("../assets/images/banner_img_3.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={700}
                    height={391}
                  />
                  <Button className="primary_btn mt-4 d-block  d-xl-none">
                    Join the Action!
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <div
            className="black_card grey"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            <Row>
              <Col xl="5">
                <div className="tag_tittle">Wingo</div>
                <div className="tag_head">
                  <div className="card_head">
                    <div className="outline">Colour</div>
                    Colour
                  </div>
                </div>

                <p className="card_p">
                  Challenge Your Instincts with the Ultimate Colour Game!
                </p>
                <Button className="primary_btn mt-3 d-none  d-xl-block">
                  Get’s Started
                </Button>
              </Col>
              <Col xl="7">
                <div className="img_right">
                  <img
                    src={require("../assets/images/banner_img_4.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={700}
                    height={391}
                  />
                  <Button className="primary_btn mt-4 d-block  d-xl-none">
                    Get’s Started
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <div
            className="black_card gold"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            <Row>
              <Col xl="5">
                <div className="tag_tittle">Wingo</div>
                <div className="tag_head">
                  <div className="card_head">
                    <div className="outline">Big Small</div>
                    Big Small
                  </div>
                </div>

                <p className="card_p">
                  Big or Small? Predict Right, Win Big!
                </p>
                <Button className="primary_btn mt-3 d-none  d-xl-block">
                  Get’s Started
                </Button>
              </Col>
              <Col xl="7">
                <div className="img_right">
                  <img
                    src={require("../assets/images/banner_img_5.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={700}
                    height={391}
                  />
                  <Button className="primary_btn mt-4 d-block  d-xl-none">
                    Get’s Started
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <div
            className="black_card orange"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            <Row>
              <Col xl="5">
                <div className="tag_tittle">Wingo</div>
                <div className="tag_head">
                  <div className="card_head">
                    <div className="outline">Cockfight</div>
                    Cockfight
                  </div>
                </div>

                <p className="card_p">
                  Clash, conquer, and rule the roost in the ultimate feathered
                  showdown!
                </p>
                <Button className="primary_btn mt-3  d-none  d-xl-block">
                  Begin Your Journey
                </Button>
              </Col>
              <Col xl="7">
                <div className="img_right">
                  <img
                    src={require("../assets/images/banner_img_6.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={700}
                    height={391}
                  />
                  <Button className="primary_btn mt-4 d-block  d-xl-none">
                    Get’s Started
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <div
            className="black_card voilet"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            <Row>
              <Col xl="5">
                <div className="tag_tittle">Wingo</div>
                <div className="tag_head">
                  <div className="card_head">
                    <div className="outline">Crypto11</div>
                    Crypto11
                  </div>
                </div>

                <p className="card_p">
                  Predict. Play. Profit – Only on Crypto11!
                </p>
                <Button className="primary_btn mt-3  d-none  d-xl-block">
                  Get’s Started
                </Button>
              </Col>
              <Col xl="7">
                <div className="img_right">
                  <img
                    src={require("../assets/images/banner_img_7.png")}
                    alt="img"
                    className="img-fluid mx-auto"
                    width={700}
                    height={391}
                  />
                  <Button className="primary_btn mt-4 d-block  d-xl-none">
                    Get’s Started
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <section className="me-0 ms-0 sec_2 p-0">
        <div className="sec_4">
          <Row>
            <Col xxl="6" xl="6">
              <div className="sec_4_head">
                <h2
                  className="sub_tittle pb-0"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="1000"
                >
                  Download Wingo
                </h2>
                <h2
                  className="sub_tittle pb-4"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="1000"
                >
                  The Ultimate Mobile Gaming Experience
                </h2>
                <p
                  className="para"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="1000"
                >
                  Battle, build, and conquer in a world where every tap brings
                  you closer to victory. Join millions of players and play
                  anytime, anywhere!
                </p>
                <div
                  className="btn_center"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="1000"
                >
                  <Button className="nav_btn mt-4">
                    <img
                      src={play}
                      alt="img"
                      className="img-fluid me-2"
                      width={24}
                      height={24}
                    />
                    Download
                  </Button>
                </div>
              </div>
            </Col>
            <Col xxl="6" lg="5" className="d-none d-xl-block">
              <div className="image_after "></div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="faq_sec">
        <Container>
          <div className="">
            <Row>
              <Col xl="3" lg="5">
                <div className="">
                  <h1
                    className="tittle"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-duration="1000"
                  >
                    Frequently Asked Questions
                  </h1>
                </div>
              </Col>
              <Col xl="9" lg="7">
                <div
                  className="accordion acc_scroll"
                  id="accordionExample2"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="1000"
                >
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => {

                      var id = `consultQuest-${i}`
                      var id1 = `consultCollapse-${i}`
                      var no = i + 1;
                      return (
                        <div className="accordion-item acc_item custom_acc_item">
                          <h2 className="accordion-header" id={id}>
                            <button
                              className={i == 0 ? "accordion-button acc_btn" : "accordion-button acc_btn collapsed"}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#${id1}`}
                              aria-expanded={i == 0 ? "true" : "false"}
                              aria-controls={`${id1}`}
                            >
                              {no}.{item?.question}
                            </button>
                          </h2>
                          <div
                            id={`${id1}`}
                            className={i == 0 ? "accordion-collapse collapse show" : "accordion-collapse collapse"}
                            aria-labelledby={id}
                            data-bs-parent="#accordionExample2"
                          >
                            <div className="accordion-body acc_body">
                              {item?.answer}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="collaboration">
        <Container>
          <h2
            className="sub_tittle pb-5"
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
          >
            In collaboration with
          </h2>
          <Slider {...settings} className="image_slider_head">
            <div className="image_slide">
              <img
                src={require("../assets/images/image-1.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-2.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-3.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-4.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-5.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-6.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-7.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-8.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-9.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-10.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-11.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-12.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-13.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
            <div className="image_slide">
              <img
                src={require("../assets/images/image-14.png")}
                alt="img"
                className="img-fluid mx-auto"
                width={194}
                height={90}
              />
            </div>
          </Slider>
        </Container>
      </section>
      <MyFooter />
    </>
  );
}
